<template>
  <div>
    <!-- <base-breadcrumb></base-breadcrumb> -->

    <card-loading-transparent v-if="loading"></card-loading-transparent>
    <v-alert type="error" :value="true" v-if="!loading && !one_project.id">
      Houve um erro.
    </v-alert>

    <template v-if="!loading && one_project.id">
      <base-card v-if="!loading && one_project.id" with_divider :with_actions="false">
        <template slot="title">
          <v-menu
            v-model="menu_color"
            offset-x
            width="300px"
            :close-on-content-click="false"
            rounded="lg"
            :disabled="!can_edit"
          >
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon :color="one_project.color">
                <v-icon style="border-radius: 20px">mdi-square-rounded</v-icon>
              </v-btn>
            </template>
            <v-card width="330px">
              <v-card-text>
                <v-color-picker
                  v-model="color"
                  dot-size="25"
                  hide-sliders
                  hide-mode-switch
                  mode="hexa"
                  show-swatches
                  swatches-max-height="200"
                  :value="the_color"
                ></v-color-picker>
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn small text @click="menu_color=false" color="primary">ok</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
          <v-text-field
            ref="project_name"
            :placeholder="$t('projects.name_form_label')"
            solo
            flat
            class="black--text"
            style="font-weight: 900 !important; font-size: large !important"
            v-model="one_project.name"
            dense
            hide-details
            :rules="required"
            @change="updateProjectField('name')"
            :disabled="!can_edit"
            @blur="handleBlur($event, 'name', 'project_name')"
            :outlined="isOutlined"
            @focus="handleFocus"
          ></v-text-field>
        </template>
  
        <template slot="btn-slot">
          <v-btn
            color="accent"
            rounded
            small
            class="elevation-0 text-capitalize mr-2"
            @click="openDocument()"
          >
            <b class="black--text">
              {{ $t("projects.documents") }}
            </b>
          </v-btn>
          <v-btn
            color="primary"
            rounded
            small
            class="white--text elevation-0 text-capitalize"
            @click="addStage()"
            :disabled="!can_edit && !$can('update', new entities.Project(one_project.use_type, one_project.status))"
          >
            <v-icon left small>mdi-plus</v-icon>
            {{ $t("stages.add_new") }}
          </v-btn>
        </template>
  
        <template v-slot:content>
          <v-form ref="projectForm" :disabled="!can_edit">
            <v-row align="center" class="px-0">
              <v-col cols="12" sm="6" md="4" class="pa-0 px-1">
                <v-select rounded outlined dense class="rounder" 
                  multiple chips small-chips
                  :loading="loading_users"
                  :items="users"
                  item-text="name"
                  item-value="id"
                  v-model="one_project.user_ids"
                  @change="updateProjectField('user_ids')"
                  :label='$t("projects.responsible")'
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip small v-if="index === 0">
                      <span>{{ item.name }}</span>
                    </v-chip>
                    <span
                      v-if="index === 1"
                      class="grey--text text-caption"
                    >
                      (+{{ one_project.user_ids.length - 1 }} {{ $t('others') }})
                    </span>
                  </template>
                </v-select>
              </v-col>
    
              <v-col cols="12" sm="6" md="4" class="pa-0 px-1">
                <v-select rounded outlined dense class="rounder" 
                  chips small-chips
                  :loading="loading_clients"
                  :items="clients"
                  item-text="name"
                  item-value="id"
                  v-model="one_project.client_id"
                  @change="updateProjectField('client_id')"
                  :label='$t("clients.client")'
                >
                </v-select>
              </v-col>
  
              <v-col cols="12" sm="6" md="4" class="pa-0 px-1">
                <v-row class="px-3" align='center' justify='space-around'>
                  <v-col cols="5" class="pa-0 pl-3">
                    <div class="mb-7">
                      <b class="subtitle-1 black--text mr-2">Status </b>
                      <v-menu v-model="status_menu" :disabled="!can_edit" offset-y :close-on-content-click="false" width="300px">
                        <template v-slot:activator="{on}">
                          <v-tooltip top>
                            <template v-slot:activator="{on}">
                              <v-chip @click="status_menu = true" v-on="on" class="px-1" :color="`status_${one_project.status}`">
                                <v-avatar  size="20" :color="`status_${one_project.status}`" class="ml-0">
                                  <v-icon x-small :color="`status_${one_project.status}_dot`">mdi-circle</v-icon>
                                </v-avatar>
                              </v-chip>
                            </template>
                            {{ $t(`statuses.${one_project.status}`) }}
                          </v-tooltip>
                        </template>
                        
                        <v-list v-if="status_menu">
                          <v-list-item v-for="status in statuses_options" :key="status" @click="one_project.status = status; updateProjectField('status')">
                            <v-list-item-content>
                              {{$t(`statuses.${status}`)}}
                            </v-list-item-content>
                          </v-list-item>
                          <!-- <v-list-item @click="() => {}">
                            <v-list-item-content>
                              aaaaa
                            </v-list-item-content>
                          </v-list-item> -->
                          
                        </v-list>
                      </v-menu>
                    </div>
                  </v-col>
  
                  <v-col cols="7" class="pa-0 mb-7">
                    <vc-date-picker v-model="one_project.expected_conclusion_at" @input="updateProjectField('expected_conclusion_at')">
                      <template v-slot="{ inputValue, togglePopover }">
                        <v-chip color="whitegrey" text-color="" @click="can_edit && togglePopover()">
                          <v-avatar left>
                            <v-icon color="secondary">mdi-calendar</v-icon>
                          </v-avatar>
                          {{ $t('projects.conclusion') }}: 
                          {{ one_project.expected_conclusion_at && $dayjs(one_project.expected_conclusion_at).format('DD/MM/YYYY') || '' }}
                        </v-chip>
                        <v-text-field v-if="false" rounded outlined dense class="rounder" 
                          :label="$t('projects.expected_conclusion_at')"
                          :value="one_project.expected_conclusion_at && $dayjs(one_project.expected_conclusion_at).format('DD/MM/YYYY') || ''"
                          @focus="togglePopover()"
                          readonly
                        ></v-text-field>
                      </template>
                    </vc-date-picker>
                  </v-col>
                </v-row>
              </v-col>
    
              <v-col cols="12" sm="6" md="4" class="pa-0 px-1">
                <v-text-field rounded outlined dense class="rounder" 
                  filled
                  v-model="one_project.kind"
                  :label='$t("projects.kind")'
                  @change="updateProjectField('kind')"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="4" class="pa-0 px-1">
                <v-text-field rounded outlined dense class="rounder" 
                  filled
                  v-model="one_project.area"
                  :label='$t("projects.area")'
                  suffix="m2"
                  @change="updateProjectField('area')"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="4" class="pa-0 px-1">
                <v-text-field rounded outlined dense class="rounder" 
                  filled
                  v-model="one_project.whole_address"
                  :label='$t("projects.address")'
                  @change="updateProjectField('whole_address')"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="4" class="pa-0 px-1">
                <v-text-field rounded outlined dense class="rounder" 
                  filled
                  v-model="one_project.payment_kind"
                  :label='$t("projects.payment_kind")'
                  @change="updateProjectField('payment_kind')"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="4" class="pa-0 px-1">
                <v-text-field rounded outlined dense class="rounder" 
                  filled
                  v-model="one_project.partials_qtd"
                  :label='$t("projects.partials_qtd")'
                  @change="updateProjectField('partials_qtd')"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="4" class="pa-0 px-1">
                <v-text-field rounded outlined dense class="rounder" 
                  filled
                  v-model="one_project.partials_value"
                  :label='$t("projects.partials_value")'
                  @change="updateProjectField('partials_value')"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="4" class="pa-0 px-1">
                <v-text-field rounded outlined dense class="rounder" 
                  filled
                  v-model="one_project.payment_status"
                  :label='$t("projects.payment_status")'
                  @change="updateProjectField('payemnt_status')"
                ></v-text-field>
              </v-col>
            </v-row>
  
            <div>
              <b class="subtitle-1 black--text mb-7 mr-2">
                {{ $t("projects.description") }}:
              </b>
            </div>
            <v-textarea
              class="rounder"
              rows="3"
              filled
              label="Escreva aqui"
              auto-grow
              v-model="one_project.description"
              @change="updateProjectField('description')"
            ></v-textarea>
          </v-form>


        </template>
      </base-card>
  
      <project-stages-list></project-stages-list>
  
      <dialog-document-list v-if="open_document_dialog" @close="handleCloseDocument" model_used="Project" :project_id="one_project.id"></dialog-document-list>
  
      <!-- <document-project
        :project="this.one_project"
        :open="this.open_document_dialog"
        @done="handleDoneStage"
        @cancel="handleCancelDocument"
      >
      </document-project> -->
  
      <dialog-new-stage
        v-if="new_stage"
        :max_positions="one_project.stage_count + 1"
        :position="stage_position"
        @done="handleDoneStage"
        @cancel="handleCancelStage"
      ></dialog-new-stage>
    
    </template>

  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";
import validations from "@/mixins/validations";
import request_error_catch from '@/mixins/request_error_catch'
import Api from "@/api/index";
import ProjectStagesList from "./stages/ProjectStagesList.vue";
// import DocumentProject from "./DocumentProject.vue";
import DialogNewStage from "./control/DialogNewStage.vue";
import DialogDocumentList from '../document/DialogDocumentList.vue';
import entities from '@/utils/entities';

export default {
  name: "OneProject",
  mixins: [validations, request_error_catch],
  components: {
    ProjectStagesList,
    // DocumentProject,
    DialogNewStage,
    DialogDocumentList,
    //ComponentName: () => import(''),
  },
  data() {
    return {
      loading: false,
      loading_clients: false,
      loading_users: false,

      entities: entities,

      one_project: {},
      one_project_bkp: {},

      status_menu: false,

      clients: [],
      users: [],

      statuses_options: [
        "not_started", "doing", "overdue", "canceled", "done", "waiting" 
      ],

      open_document_dialog: false,
      new_stage: false,
      stage_position: null,

      the_color: null,
      menu_color: false,

      isOutlined: false,
    };
  },
  methods: {
    addStage() {
      this.new_stage = true;
      this.stage_position = this.one_project.stage_count + 1;
    },
    openDocument() {
      this.open_document_dialog = true;
    },
    handleCloseDocument(e) {
      this.open_document_dialog = false;
    },
    handleDoneStage(e) {
      // console.log({e});
      e = {
        ...e,
        project_id: this.one_project.id,
        company_id: this.one_project.company_id,
      };

      this.createStage(e);
    },
    handleCancelStage(e) {
      this.new_stage = false;
      this.stage_position = null;
    },
    createStage(stage) {
      this.loading = true;
      Api.Stage.create(stage)
        .then((r) => r.data)
        .then((d) => {
          this.$refs.template_stage_list.getStages();
          this.handleCancelStage();
        })
        .catch((err) => {
          console.log({ err });
        })
        .finally(() => (this.loading = false));
    },
    handleFocus(e) {
      // console.log({e});
      // const text_field = e.target.parentElement.parentElement.parentElement.parentElement
      // console.log({text_field});
      // text_field.classList.add("mb-2")
      this.isOutlined = true;
      // this.$refs.project_name.outlined = true
      // Alterei pq deu o seguinte erro: Avoid mutating a prop directly since the value will be overwritten whenever the parent component re-renders.
      // Instead, use a data or computed property based on the prop's value. Prop being mutated: "outlined"
    },
    handleBlur(e, field, ref) {
      const {
        target: {
          validity: { valid },
          validationMessage,
          _value,
        },
      } = e;
      // console.log({e, tg: e.target, vld: e.target.validity, valid});
      const text_field = e.target.parentElement.parentElement.parentElement.parentElement;
      // console.log({text_field, pc: text_field._prevClass});

      let is_valid = true;

      // console.log(this.$refs[ref]);

      if (!valid || text_field._prevClass.includes("error--text")) {
        is_valid = false;
      }

      if (ref && ref == "project_name") {
        this.isOutlined = false;
        // this.$refs.project_name.outlined = false
      }

      if (!is_valid) {
        let msg = validationMessage || text_field.textContent;
        if (!msg && ref) {
          msg = this.$refs[ref].messagesToDisplay;
        } else if (!msg && !ref) {
          msg = "Houve um erro.";
        }
        text_field.classList.add("rounder_error");
        // e.target.parentElement.parentElement.parentElement.parentElement.classList.add("")
        // e.target.placeholder = 'Template needs a name'
        this.addNotification({ type: "error", msg });
      } else {
        // console.log('ee', field);
        // this.updateStageField(field, _value)
      }
    },
    getTemplateProject() {
      this.loading = true;
      Api.Project.show(this.$route.params.id)
        .then((r) => r.data)
        .then((d) => {
          // console.log({d});
          this.one_project = {
            ...d,
            ...d.json_attributes,
            user_ids: d.users.map(({id})=> id)
          };

          this.one_project_bkp = { ...d };
          this.the_color = this.one_project.color || '#CCCCCC';
        })
        .catch((err) => {
          console.log({ err });
        })
        .finally(() => (this.loading = false));
    },
    getClients() {
      this.loading_clients = true;
      Api.Client.index().then((r) => r.data).then((d) => {
        this.clients = [...d];
      }).catch((err) => {
        console.log({ err });
      }).finally(() => {
        this.loading_clients = false;
      });
    },
    getUsers(){
      this.loading_users = true
      Api.User.index().then(r=> r.data).then(d=> {
        this.users= [ ...d ]
      }).catch(err=>{
        console.log({err});
      }).finally(()=> {
        this.loading_users = false
      })
    },
    updateProjectField(field) {
      // console.log(this.one_project[field])
      if (this.one_project[field]) {
        let obj = {
          id: this.$route.params.id,
        };
        obj[field] = this.one_project[field];
        Api.Project.update(obj).then((r) => r.data).then((d) => {
          this.one_project = {
            ...this.one_project,
            ...d,
            ...d.json_attributes,
          };
          this.addNotification({msg: 'Atualizado com sucesso', type: 'success'})
        }).catch(err=> {
          console.log({err});
          this.addNotification({type: 'error', msg: err})
        }).finally(()=>{

        })
      } else {
      }
    },
    ...mapActions({
      // function: 'Module/action'
      addNotification: "Notification/add",
    }),
  },
  computed: {
    can_reopen_project(){
      if (this.profile && this.one_project.id){
        const user_roles_allowed = ['super_admin', 'admin']
        const proj_status_allowed = ['canceled', 'done']

        const proj_is_editable = proj_status_allowed.includes(this.one_project.status)

        return user_roles_allowed && proj_is_editable
      }
      return false
    },
    can_edit(){
      if (this.profile && this.profile.id && this.one_project.id){
        const user_roles_allowed = ['super_admin', 'sys_admin', 'admin', 'user']
        const employee_roles_allowed = ['admin', 'employee']

        const is_user_allowed = user_roles_allowed.includes(this.profile.roles[0].name)
        const is_employee_allowed = employee_roles_allowed.includes(this.profile.employee.roles[0].name)

        const same_company = this.one_project.company_id == this.profile.employee.company_id
        const in_project = this.one_project.user_ids.includes(this.profile.id)

        const proj_status_not_allowed = ['canceled', 'done']
        const proj_status_allowed = ['not_started', 'doing', 'overdue']
        const proj_is_editable = proj_status_allowed.includes(this.one_project.status)

        // console.log(same_company , is_user_allowed , is_employee_allowed , in_project , proj_is_editable)

        // return same_company && is_user_allowed && (((is_employee_allowed || in_project) && proj_is_editable) || this.profile.employee.roles[0].name == 'admin')
        return same_company && this.$can('update', new entities.Project(this.one_project.use_type, this.one_project.status))

        // return true
      }
      return false
    },
    color: {
      get() {
        return this.the_color;
      },
      set(v) {
        this.the_color = v;
        this.one_project.color = v;
      },
    },
    ...mapState({
      profile: (state) => state.User.oneUser,

      // data: state=> state.Module.state_var
    }),
  },
  mounted() {
    this.getTemplateProject();
    this.getClients();
    this.getUsers();
  },
  watch: {
    the_color(nv, ov) {
      if (nv) {
        this.one_project.color = nv;
      } else if (nv == false) {
      }
    },
    menu_color(nv, ov) {
      if (nv == false) {
        if (this.one_project.color != this.one_project.json_attributes.color || !this.one_project.json_attributes.color) {
          this.updateProjectField("color");
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep.rounder_error.v-input--dense.v-text-field--single-line
  > .v-input__control
  > .v-input__slot {
  color: #ff00ff !important;
  // background-color: #ff0000;
  /* min-height: 30px !important; */
}
::v-deep.rounder_error.v-input--dense.v-text-field--single-line
  > .v-input__control
  > .v-input__slot
  ::placeholder {
  color: #ff0000 !important;
  // background-color: #ff0000;
  /* min-height: 30px !important; */
}
</style>
